init_al = ->
  list_type = $(document).find('[data-list-type]')
  list_type.on 'change', (e) =>
    type = list_type.val()
    handle_type(type)

handle_type = (type) ->
  list_values = $(document).find('[data-list-values]')
  list_tags = $(document).find('[data-list-tags]')
  attrForDisabledField = 'disabled'
  if list_values.attr('data-read-attr') != undefined && list_values.attr('data-read-attr').length > 0
    attrForDisabledField = list_values.attr('data-read-attr')

  if type is 'automated'
    list_values.attr attrForDisabledField, true
    list_tags.attr 'disabled', true
    list_tags.hide();
  else
    list_values.attr attrForDisabledField, false
    list_tags.attr 'disabled', false
    list_tags.show();

$ ->
  init_al()
